import { useTranslation } from 'react-i18next';
import { useGridLikeFlexChildProps } from '../../components/GridLikeFlex';
import { useEditor } from '../../../WYSIWYG';
import {
  TextEditorToolbarSection,
  ToggleButton,
  ToolbarIcon,
} from '../../styles';

export const HorizontalRuleToolbarSection = () => {
  const { t } = useTranslation();
  const [ref, props] = useGridLikeFlexChildProps();
  const editor = useEditor();

  if (!editor) return null;

  return (
    <TextEditorToolbarSection ref={ref} {...props}>
      <ToggleButton
        title={t('Horizontal Rule')}
        onClick={() => editor.chain().focus().setHorizontalRule().run()}
      >
        <ToolbarIcon
          icon="horizontal-rule"
          color="var(--color-background-darker)"
        />
      </ToggleButton>
    </TextEditorToolbarSection>
  );
};
